import { Card, CardContent, Grid } from '@material-ui/core'
import {
  components,
  constants,
  useTranslation
} from 'cng-web-lib'

import VsMigrationSyncLogApiUrls from 'src/apiUrls/VsMigrationSyncLogApiUrls'
import React from 'react'
import VsMigrationSyncLogKeys from 'src/constants/locale/key/VsMigrationSyncLog'
import Namespace from 'src/constants/locale/Namespace'

const {
  card: { CngSimpleCardHeader },
  table: {
    CngCrudTable,
    DateRangeFilter: CngDateRangeFilter,
    useDefaultNotification
  }
} = components

const {
  locale: {
    key: { UiComponentKeys }
  }
} = constants

function TablePage(props) {
  const {
    location: { pathname },
    showNotification
  } = props

  const notification = useDefaultNotification(showNotification)
  const { translate } = useTranslation([
    Namespace.UI_COMPONENT,
    Namespace.VS_MIGRATION_SYNC_LOG
  ])
  const translatedTextsObject = makeTranslatedTextsObject()

  function makeTranslatedTextsObject() {
    let vsMigrationSyncLog = translate(
      Namespace.VS_MIGRATION_SYNC_LOG,
      VsMigrationSyncLogKeys.TITLE
    )
    let tableTitle = translate(
      Namespace.UI_COMPONENT,
      UiComponentKeys.Table.TITLE,
      {
        nameTitleised: vsMigrationSyncLog
      }
    )
    let source = translate(
      Namespace.VS_MIGRATION_SYNC_LOG,
      VsMigrationSyncLogKeys.SOURCE
    )
    let destination = translate(
      Namespace.VS_MIGRATION_SYNC_LOG,
      VsMigrationSyncLogKeys.DESTINATION
    )
    let vesselName = translate(
      Namespace.VS_MIGRATION_SYNC_LOG,
      VsMigrationSyncLogKeys.VESSEL_NAME
    )
    let voyageNo = translate(
      Namespace.VS_MIGRATION_SYNC_LOG,
      VsMigrationSyncLogKeys.VOYAGE_NO
    )
    let migrationTime = translate(
      Namespace.VS_MIGRATION_SYNC_LOG,
      VsMigrationSyncLogKeys.MIGRATION_TIME
    )
    let retry = translate(
      Namespace.VS_MIGRATION_SYNC_LOG,
      VsMigrationSyncLogKeys.RETRY
    )
    let startTime = translate(
      Namespace.VS_MIGRATION_SYNC_LOG,
      VsMigrationSyncLogKeys.START_TIME
    )
    let endTime = translate(
      Namespace.VS_MIGRATION_SYNC_LOG,
      VsMigrationSyncLogKeys.END_TIME
    )
    let processStatus = translate(
      Namespace.VS_MIGRATION_SYNC_LOG,
      VsMigrationSyncLogKeys.PROCESS_STATUS
    )
    let errorLog = translate(
      Namespace.VS_MIGRATION_SYNC_LOG,
      VsMigrationSyncLogKeys.ERROR_LOG
    )
    let content = translate(
      Namespace.VS_MIGRATION_SYNC_LOG,
      VsMigrationSyncLogKeys.CONTENT
    )
    let processResponse = translate(
      Namespace.VS_MIGRATION_SYNC_LOG,
      VsMigrationSyncLogKeys.PROCESS_RESPONSE
    )

    return {
      vsMigrationSyncLog,
      tableTitle,
      source,
      destination,
      vesselName,
      voyageNo,
      migrationTime,
      retry,
      startTime,
      endTime,
      processStatus,
      errorLog,
      content,
      processResponse
    }
  }

  const columns = [
    {
      field: "source",
      title: translatedTextsObject.source,
    },
    {
      field: "destination",
      title: translatedTextsObject.destination,
    },
    {
      field: "vesselName",
      title: translatedTextsObject.vesselName,
    },
    {
      field: "voyageNo",
      title: translatedTextsObject.voyageNo,
    },
    {
      field: "migrationTime",
      title: translatedTextsObject.migrationTime,
      type: "datetime",
      filterComponent: CngDateRangeFilter,
      defaultSort: "desc"
    },
    {
      field: "retry",
      title: translatedTextsObject.retry,
      type: "numeric",
    },
    {
      field: "startTime",
      title: translatedTextsObject.startTime,
      type: "datetime",
      filterComponent: CngDateRangeFilter,
    },
    {
      field: "endTime",
      title: translatedTextsObject.endTime,
      type: "datetime",
      filterComponent: CngDateRangeFilter,
    },
    {
      field: "processStatus",
      title: translatedTextsObject.processStatus,
    },
    {
      field: "errorLog",
      title: translatedTextsObject.errorLog,
    }
  ]

  return (
    <Card>
      <CngSimpleCardHeader title={translatedTextsObject.tableTitle} />
      <CardContent>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <CngCrudTable
              {...props}
              fieldLevel="toBeChangedByDeveloperIfWantFieldLevelRestriction"
              // addRoute={`${pathname}/add`}
              columns={columns}
              del={{ url: VsMigrationSyncLogApiUrls.DELETE }}
              editRoute={`${pathname}/edit`}
              exportData={{ url: VsMigrationSyncLogApiUrls.EXPORT }}
              fetch={{ url: VsMigrationSyncLogApiUrls.GET }}
              idAccessor="id"
              notification={notification}
              //tableConfigurationCode="REPLACE_WITH_CORE_TABLE_CONFIG_CODE"
              viewRoute={`${pathname}/view`}
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  )
}

export default TablePage
